import { mapboxSearchKey } from "../../api-keys";
import { MapboxSearchResults } from "./map-search-types";

const MAPBOX_SEARCH_API_URL_BASE = "https://api.mapbox.com/search/searchbox/v1/forward";

const MAPBOX_SEARCH_API_TOKEN = mapboxSearchKey;

export async function searchMapboxApi(searchString: string): Promise<MapboxSearchResults> {
    if (searchString.length === 0) {
        return {
            type: "FeatureCollection",
            features: [],
        } as MapboxSearchResults;
    }
    const results = await fetch(generateMapboxSearchApiUrl(searchString), {
        method: "GET",
    });
    const parsedResults = await results.json();
    return parsedResults;
}

function generateMapboxSearchApiUrl(searchString: string) {
    // Properly encode the query string for use in a URL
    return `${MAPBOX_SEARCH_API_URL_BASE}?q=${encodeURIComponent(searchString)}&access_token=${MAPBOX_SEARCH_API_TOKEN}`;
}
